/**
 * This function takes a number as argument and formats it using parameters
 * @param number
 * @param precision
 * @param decimalSeparator
 * @param thousandSeparator
 * @return {string}
 */
export default function (number, precision = 0, decimalSeparator = ', ', thousandSeparator = ' ') {
  let value = number;
  const sign = value < 0 ? '-' : '';
  const amountStr = String(parseInt((value = Math.abs(+value || 0)), 10));

  const firstDigitsLen = amountStr.length > 3 ? amountStr.length % 3 : 0;
  const firstDigits = firstDigitsLen
    ? amountStr.substr(0, firstDigitsLen) + thousandSeparator
    : '';
  const digits = amountStr
    .substr(firstDigitsLen)
    .replace(/(\d{3})(?=\d)/g, `$1${thousandSeparator}`);
  const integerPart = `${firstDigits}${digits}`;

  let fractionalPart = Math.abs(value - amountStr)
    .toFixed(precision)
    .slice(2);
  fractionalPart = precision ? decimalSeparator + fractionalPart : '';

  return `${sign}${integerPart}${fractionalPart}`;
}
